// @flow
import * as React from 'react';
import { withRouter } from 'react-router';
import CablePanel from 'esm-web-pro/containers/pages/network/objects/cable/CablePanel';
import PatchCableEditor from 'esm-web-pro/containers/pages/network/objects/cable/patch/PatchCableEditor';
import MapPoint from 'esm-web-pro/containers/pages/network/objects/MapPoint';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { Map } from 'esm-web-pro/containers/map/types';
import type { Cable } from 'esm-web-pro/types/networks';


type Props = {
    object: Cable,
    map: Map,
    updateObject: Function,
    editor: BaseEditor,
};

const PatchCable = (props: Props) => {
    const {
        object: cable, map, updateObject, editor,
    } = props;

    return (
        <>
            <MapPoint cable={cable} editor={editor} />
            <CablePanel
                cable={cable}
                editor={PatchCableEditor}
                map={map}
                mapEditor={editor}
                handleView={() => {}}
                updateObject={updateObject}
            />
        </>
    );
};

export default withRouter(PatchCable);
